import { useState, useEffect } from 'react';

/**
 * Use decounce is a function that delays the input entered by the speciified time
 * If a new value is entered it will clear the timeout.
 * This function returns the value you passed to it as a param after with the delay time is over
 */
export default function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const tid = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(tid);
    };
  }, [value, delay]);

  return debouncedValue;
}